<!-- Плоская секция реальных read-only данных выбранного титула ЭДО. -->
<template>
  <section class="edo-title-data-section">
    <header class="edo-title-data-section__header">
      <EdoSectionIcon
        class="edo-title-data-section__icon"
        :name="iconName"
      />
      <h4 class="edo-title-data-section__title">{{ section.title }}</h4>
    </header>

    <slot />

    <div v-if="section.rows && section.rows.length" class="edo-title-data-section__rows">
      <EdoDocumentPreviewRow
        v-for="row in section.rows"
        :key="row.key"
        :row="row"
      />
    </div>
  </section>
</template>

<script>
import EdoDocumentPreviewRow from "@/components/Edo/shared/EdoDocumentPreviewRow.vue";
import EdoSectionIcon from "@/components/Edo/shared/icons/EdoSectionIcon.vue";

export default {
  name: "EdoDocumentTitleDataSection",

  components: {
    EdoDocumentPreviewRow,
    EdoSectionIcon,
  },

  props: {
    section: {
      type: Object,
      required: true,
    },
  },

  computed: {
    iconName() {
      if (this.section.icon) return this.section.icon;
      if (this.section.key === "transport") return "vehicle";
      if (this.section.key === "planned") return "document";

      return this.section.key;
    },
  },
};
</script>

<style scoped>
.edo-title-data-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 22px 0;
  border-top: 1px solid #eef0f5;
}

.edo-title-data-section:nth-child(-n + 2) {
  border-top: 0;
}

.edo-title-data-section__header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edo-title-data-section__icon {
  color: #475569;
}

.edo-title-data-section__title {
  margin: 0;
  color: var(--color-dark);
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
}

.edo-title-data-section__rows {
  display: grid;
  gap: 8px;
}

@media (max-width: 720px) {
  .edo-title-data-section {
    padding: 18px 0;
  }

  .edo-title-data-section:nth-child(2) {
    border-top: 1px solid #eef0f5;
  }
}
</style>
